import React from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import PdfDisplay from "./PdfDisplay";

const VerifyDocsModal = ({ show, handleClose, rejectDoc, acceptDoc, govermentIssuedId, selfie, isSelfCheckInIdentityVerified }) => {
  const govermentIssuedIdLink = govermentIssuedId?.substring(0, govermentIssuedId?.indexOf('?'));
  const govermentIssuedIdFileFormat = govermentIssuedIdLink?.substring(govermentIssuedIdLink?.lastIndexOf('.') + 1);
  
  const selfieURLLink = selfie?.substring(0, selfie?.indexOf('?'));
  const selfieFileFormat = selfieURLLink?.substring(selfieURLLink?.lastIndexOf('.') + 1);
  return (
    <Modal size="xl" show={show} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Body>
        <Row>
          <Col>
            <h6 style={{ fontWeight: "600" }}>Government issued ID</h6>
            {govermentIssuedId && govermentIssuedIdFileFormat === "pdf" ?
              <PdfDisplay fileUrl={govermentIssuedId} /> :
              <img
                alt="doc"
                style={{
                  width: "100%",
                  height: "90%",
                  objectFit: "contain",
                  background: "#D9D9D9",
                  border: "1px solid",
                  borderColor: "gray",
                  padding: 10,
                  marginTop: 20
                }}
                src={govermentIssuedId}
              />
            }
          </Col>
          <Col>
            <h6 style={{ fontWeight: "600" }}>Patient photo</h6>
            {selfie && selfieFileFormat === "pdf" ?
              <PdfDisplay fileUrl={govermentIssuedId} /> :
              <img
                alt="doc2"
                style={{
                  width: "100%",
                  height: "90%",
                  objectFit: "contain",
                  background: "#D9D9D9",
                  border: "1px solid",
                  borderColor: "gray",
                  padding: 10,
                  marginTop: 20
                }}
                src={selfie}
              />
            }
            
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row style={{ width: "100%", display: "flex", justifyContent: "space-between",paddingRight: 15 }}>
          <Button variant="dark" onClick={handleClose}>
            Close
          </Button>
          <Row style={{ width: "33%", display: "flex", justifyContent: "space-between" }}>
            <Button
              className={isSelfCheckInIdentityVerified === undefined ? "" : "disable-verify-document-button"}
              variant="outline-light"
              onClick={rejectDoc}
              style={{ paddingLeft: 60, paddingRight: 60, color: "#007F61", borderColor: "#007F61" }}
              disabled={isSelfCheckInIdentityVerified !== undefined}
            >
              Reject
            </Button>
            <Button
              className={isSelfCheckInIdentityVerified === undefined ? "" : "disable-verify-document-button" }
              variant="light"
              onClick={acceptDoc}
              style={{ paddingLeft: 60, paddingRight: 60, background: "#007F61", color: "white", border: "none" }}
              disabled={isSelfCheckInIdentityVerified !== undefined}
            >
              Accept
            </Button>
          </Row>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyDocsModal;
